const ACCESS_TOKEN = "ACCESS_TOKEN";
const REFRESH_TOKEN = "REFRESH_TOKEN";
const SAVED_EMAIL = "SAVED_EMAIL";

export { ACCESS_TOKEN, REFRESH_TOKEN, SAVED_EMAIL };
